module.exports = __webpack_public_path__ + "static/media/GU.4ec9d440.png";